import PropTypes from 'prop-types'
import { Trash } from '@styled-icons/boxicons-solid'
import { formatDate, formatEmptyValue } from '../../../../utils/common'
import LinkWithStatus from '../../../common/LinkWithStatus'
import CheckBox from '../../../common/CheckBox'
import { useContext } from 'react'
import { PluginContext, SET_SELECTED_IDS } from './context/context'
import Tooltip from '../../../common/tooltip'
import { ProgresSpinner } from '../../../common/ProgresSpinner'

const PluginRow = (props) => {
  const [state, dispatch] = useContext(PluginContext)

  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-1/12 items-center justify-center">
          <CheckBox
            checked={state?.selectedIds.includes(props.id)}
            onChange={(e) => {
              dispatch({ type: SET_SELECTED_IDS, data: props.id })
            }}
          />
        </div>
        <div className="flex w-3/12 items-center table_text">
          <Tooltip
            message={props.file_id ? props.file_id : props.file_names.def_file}
          >
            <div>
              {formatEmptyValue(
                props.file_id ? props.file_id : props.file_names.def_file
              )}
            </div>
          </Tooltip>
        </div>
        <div className="flex pl-6 w-3/12 items-center table_text">
          <Tooltip message={props.description}>
            <div>{formatEmptyValue(props.description)}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          {formatDate(props.created_at)}
        </div>
        <div className="flex w-3/12 pl-6 items-center">
          {state?.in_process_generate_file_ids.includes(props.id) ? (
            <ProgresSpinner caption="File Generation is in Progress ..." />
          ) : state?.in_process_upload_file_harnesses.includes(
              props.file_id
            ) ? (
            <ProgresSpinner caption="File Upload is in Progress ..." />
          ) : (
            <>
              <div>
                <LinkWithStatus
                  href={``}
                  className="btn py-1 px-2"
                  title="View Files"
                  onClickFunc={() => {
                    props.onViewFiles()
                  }}
                />
              </div>
              <LinkWithStatus
                href={``}
                className="btn py-1 px-2 ml-2"
                title="Generate Files"
                onClickFunc={() => {
                  props.generateDefFiles(props.id)
                }}
              />
              <div>
                <span
                  onClick={() => {
                    props.onDelete()
                  }}
                  className="cursor-pointer p-2"
                >
                  <Trash size="2rem" color="#0189E9" />
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

PluginRow.propTypes = {
  status: PropTypes.number,
  id: PropTypes.number,
  onViewFiles: PropTypes.func.isRequired,
  file_names: PropTypes.object,
  created_at: PropTypes.any,
}

export default PluginRow
